import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid,
} from 'recharts';
import { formatCurrency } from '../../utils/formatters';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const astro = payload[0].payload;
    return (
      <Box sx={{ bgcolor: 'background.paper', p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1, boxShadow: 2 }}>
        <Typography variant="subtitle2">{label}</Typography>
        <Typography variant="body2">{formatCurrency(astro.totalEarnings)}</Typography>
        {astro.rating != null && <Typography variant="caption" color="text.secondary">Rating: {astro.rating.toFixed(1)}</Typography>}
      </Box>
    );
  }
  return null;
};

const TopAstrologers = ({ data = [] }) => {
  if (!data.length) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
        <Typography color="text.secondary">No astrologer data available</Typography>
      </Box>
    );
  }

  const chartData = data.map((a) => ({
    ...a,
    name: (a.userId?.name || a.name || 'Unknown').slice(0, 15),
    earnings: a.totalEarnings || 0,
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData} layout="vertical" margin={{ top: 5, right: 30, left: 60, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" horizontal={false} />
        <XAxis type="number" tick={{ fontSize: 11 }} tickFormatter={(val) => `₹${(val / 1000).toFixed(0)}k`} />
        <YAxis type="category" dataKey="name" tick={{ fontSize: 11 }} width={80} />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="earnings" fill="#FFD700" radius={[0, 4, 4, 0]} barSize={20} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default TopAstrologers;
